var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"switch",class:{'switch-disabled': _vm.disabled}},[_c('input',{ref:"checkbox",attrs:{"type":"checkbox","name":_vm.name,"v-model":_vm.status,"disabled":Boolean(_vm.disabled)},domProps:{"checked":_vm.status},on:{"click":function($event){return _vm.updateFlag(!_vm.status)}}}),_c('span',{staticClass:"slider round"})])
}
var staticRenderFns = []

export { render, staticRenderFns }